<template>
  <div
    class="border-solid border-0 border-b border-gray-600 flex flex-row flex-wrap items-center"
    role="row"
    ref="container"
  >
    <div role="gridcell">
      <doe-action-box
        class="hidden md:block"
        :identifier="row.uuid"
        :isSelected="isChecked"
        :ariaLabel="`Select ${row.childsFullName.text}`"
        @input="updateSelectedItems($event)"
      />
    </div>

    <div
      v-for="(column, index) in columns"
      :key="index"
      class="flex-1 py-4 lg:block"
      :class="{
        'block': column.onMobile,
        'hidden': !column.onMobile,
        'md:hidden': !column.onTablet,
        'md:block': column.onTablet
      }"
      role="gridcell"
    >
      <div>
        <p
          @click="viewStatementAction($event)"
          v-if="row[column.value].text"
          class="block font-light font-sans leading-snug subpixel-antialiased text-base text-black flex"
          :class="{
            'font-semibold lg:font-light': column.value === 'childsFullName',
            'cursor-pointer': row.statementStatus.value !== 'archived'
          }"
        >
          <doe-icon
            v-if="column.value === 'statementStatus'"
            class="mr-1"
            :icon="statementIcon.icon"
            :colour="statementIcon.colour"
            size="large"
            :description="row[column.value].text"
          />
          <span v-if="column.value === 'statementStatus'" class="hidden md:inline-block">
            {{ row[column.value].text }}
          </span>
          <span v-else>
            {{ row[column.value].text }}
          </span>
          <span
            v-if="column.value === 'childsFullName'"
            class="lg:hidden block font-light font-sans leading-snug subpixel-antialiased text-sm text-black"
          >
            {{ row[column.value].educator }}
          </span>
        </p>
        <p
          v-else
          class="block font-light font-sans leading-snug subpixel-antialiased text-base"
        >
          Not provided
        </p>
      </div>
    </div>
    <div>
      <navigation-context
        :ariaLabel="`Actions for ${row.childsFullName.text}`"
        icon="ellipsis"
        icon-size="large"
        :actions="filteredActions"
        @click="handleRowAction($event)"
      />
    </div>
  </div>
</template>

<script>
import { STATUSES } from "@/data/options";
import DoeIcon from "@/components/icon/Icon";
import NavigationContext from "@/components/navigation/NavigationContext.vue";
import DoeActionBox from "@/components/table/ActionBox";

export default {
  name: "DoeRow",
  props: {
    actions: {
      type: Array,
      required: true
    },
    columns: {
      type: Array
    },
    row: {
      type: Object
    },
    isSelected: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      statuses: STATUSES
    };
  },
  components: {
    NavigationContext,
    DoeActionBox,
    DoeIcon
  },
  methods: {
    viewStatementAction($event) {
      this.$set($event, "statementUuid", this.row.uuid);
      this.$set($event, "lastRouteViewed", this.row.lastRouteViewed);
      this.$set($event, "action", "action:statement");
      this.$emit("row:action", $event);
    },
    updateSelectedItems($event) {
      this.$store.commit('SET_BUTTON', this.row.uuid);
      this.$emit("input", $event);
    },
    handleRowAction($event) {
      this.$set($event, "uuid", this.row.uuid);
      this.$emit("row:action", $event);
    }
  },
  computed: {
    filteredActions() {
      return this.actions.filter(action => {
        if (
          action.label === 'Delete'
          && this.row.status === 'complete'
          && this.row.visibleToSchoolTS
        ) {
          return this.row.visibleToSchoolTS > Math.round(Date.now() / 1000);
        }
        return action.allowFor.includes(this.row.status)
      });
    },
    isChecked(){
      let flag=this.$root.selectedItems.includes(this.row.uuid);
      return flag;
    },
    statementIcon() {
      let status= this.statuses.find(
        status => status.value === this.row.statementStatus.value
      );

      if( !status)
      {
        status = this.statuses[0];
      }

      return status;
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  // white-space: nowrap;
  // overflow: hidden;
  // text-overflow: ellipsis;
  max-width: 120px;
}
@media (min-width: 768px) {
  p {
    max-width: 140px;
  }
}
</style>
